import React,{useState, useEffect, useRef} from 'react'
import { BarChart,XAxis, YAxis, Tooltip, Legend, CartesianGrid,ResponsiveContainer } from 'recharts';
import './profile.css';
import emitter from './emitter';
import Header from '../layout/Header'
import Sidebar from '../layout/Sidebar'
import AxiosURL from '../../ApiService/AxiosURL';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DonutChart from 'react-donut-chart';
import { Loader } from 'rsuite';
import 'rsuite/styles/index.less';

import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Highcharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d'
import HighchartsReact from 'highcharts-react-official'

export default function Profile() {
// API call
let API="farmers/breadcrumb";
let distt = "farmers/get_districts";
let AVGDATAAPI = "farmers/averageData";
let API_Pie = "farmers/piegraph_home_data";

const [useDistricts, setDistricts] = useState([]);
const [isLoading, setIsLoading] = useState(false);
const [getVillages, setVillages] = useState([]);
const [useSelected, setSelected] = useState();
const [getDist, setDist] = useState([]);
const [users, setUsers] = useState([]);
const [year, setYear] = useState([]);
const [avgDashboardData, setAvgDashboardData] = useState([]);
const [avgDashboardDataForYeild, setAvgDashboardDataForYeild]=useState([]);
const [pieChart_users, setpieChart_users] = useState([]);
useEffect(()=>{
  Chart.register(ChartDataLabels);
  fetchAvgDataForDashboard('farmers/averageData?yearVal=2022');
  // toast.success("Successgully logIn", {position: toast.POSITION.TOP_RIGHT});
  // fetchApiData('farmers/breadcrumb?yearVal=2021');
  fetchDistricts(distt);
  fetchApiData_PieChart(API_Pie);
},[]);

const fetchAvgDataForDashboard = async(url) => {
  try{
    setIsLoading(true)
    const response = await AxiosURL.get(url);
    setAvgDashboardData(response.data.data.revenu);
    setAvgDashboardDataForYeild(response.data.data.yeild)
    setIsLoading(false)
    // console.log(avgDashboardData)
  }catch(error){
    console.log(error);
  }
} 

const fetchApiData_PieChart= async(url)=>{
  try{
    const response = await AxiosURL.get(url)
    setpieChart_users(response.data.data);
  }catch(error){
    console.log(error);      
  }
};

// const fetchApiData = async(url)=>{
//   try{
//     const response = await AxiosURL.get(url);
//     setUsers(response.data.data);
//       }catch(error){
//     console.log(error);      
//   }
// };
const fetchDistricts = async(url)=>{
  try{
       const response = await AxiosURL.get(url);
       setDistricts(response.data.data);
  }catch(error){
    console.log(error);
  }
}
const filteredByYear =async(data,yearVal)=>{
  if(data.target.value == 'select')
  {
    // fetchApiData(API);
    fetchAvgDataForDashboard(AVGDATAAPI);
  }else{
    // setDistricts([]);
    setIsLoading(true);
    const response = await AxiosURL.get(API,{ params:{"yearVal": yearVal}});
    setUsers(response.data.data);
    setIsLoading(true)
    const avgResponse = await AxiosURL.get(AVGDATAAPI,{ params:{"yearVal": yearVal}});
    setAvgDashboardData(avgResponse.data.data.revenu);
    setAvgDashboardDataForYeild(avgResponse.data.data.yeild)
    setIsLoading(false)
    emitter.emit("sendFilterData",{"yearVal": yearVal})
    setIsLoading(false);

    //  // get District district wise
    //  const resp = await AxiosURL.get('farmers/get_village/'+yearVal);
    //  setDistricts(resp.data.data);
    //  // console.log(getVillages);
  } 
}
const filteredByDistrict = async (tval)=>{
  if(tval.target.value == 'select')
  {
    // fetchApiData(API);
    fetchAvgDataForDashboard(AVGDATAAPI);
  }else{
    setVillages([]);
    // selectInputRef.select.clearValue();
    setIsLoading(true);
    var distData = tval.target.value;
    // const response = await AxiosURL.get(API,{ params:{"district": distData}});
    // setUsers(response.data.data);
    setIsLoading(true)
    const avgResponse = await AxiosURL.get(AVGDATAAPI,{ params:{"district": distData}});
    setAvgDashboardData(avgResponse.data.data.revenu);
    setAvgDashboardDataForYeild(avgResponse.data.data.yeild)
    setIsLoading(false)
    emitter.emit("sendFilterData",{"district": distData})
    setIsLoading(false);

    // get Village district wise
    const resp = await AxiosURL.get('farmers/get_village/'+distData);
    setVillages(resp.data.data);
    // console.log(getVillages);
  }    
}
const filteredByVillage = async (villVal)=>{
  if(villVal.target.value=='select')
  {
    // const response = await AxiosURL.get(API,{ params:{"district": getDist}});
    // setUsers(response.data.data);
    const avgResponse = await AxiosURL.get(AVGDATAAPI,{ params:{"district": getDist}});
    setIsLoading(true)
    setAvgDashboardData(avgResponse.data.data.revenu);
    setAvgDashboardDataForYeild(avgResponse.data.data.yeild)
    setIsLoading(false)
    emitter.emit("sendFilterData",{"district": getDist})
    // alert("no");
  }
  else
  {
    var villData = villVal.target.value;
    // const response = await AxiosURL.get(API,{ params:{"district": getDist,"village":villData}});
    // setUsers(response.data.data);
    setIsLoading(true)
    const avgResponse = await AxiosURL.get(AVGDATAAPI,{ params:{"district": getDist,"village":villData}});
     setAvgDashboardData(avgResponse.data.data.revenu);
     setAvgDashboardDataForYeild(avgResponse.data.data.yeild)
    setIsLoading(false)
    emitter.emit("sendFilterData",{"district": getDist, "village": villData});
    
  }
}
const selectInputRef = useRef();

const hideShowVillage = (props) =>{
  var length = props.length;
  var villageId = document.getElementById('villageId');
    if(length=='' || props=='select')
    {
      // villageId.style.display = "none";
    }
    else{
      // villageId.style.display = "block";
    }
}

const setAvgDashboard1 = {
  
  labels: ["Revenu Earned Per Ha", "Input Cost Per Ha"],
  datasets: [
    {
      label: "Average Income",
      // backgroundColor: "#EC932F",
      backgroundColor: ["#e01f7d","#EC932F"], 
      // borderColor: "rgba(255,99,132,1)",
      borderWidth: 15,
      hoverBackgroundColor: "rgba(255,99,132,0.4)",
      hoverBorderColor: "rgba(255,99,132,1)",
      data: avgDashboardData
    }
  ]
};


const setAvgDashboard2 = {
  
  labels: ["Income Per Ha", "Yield Per Ha"],
  datasets: [
    {
      label: "Average Yield",
      backgroundColor: ["#6610f2", "#03fc9d"], 
      // borderColor: "rgba(255,99,132,1)",
      borderWidth: 15,
      hoverBackgroundColor: "rgba(255,99,132,0.4)",
      hoverBorderColor: "rgba(255,99,132,1)",
      data: avgDashboardDataForYeild
    }
  ]
};

const optionsForBar = {
  plugins: {
    datalabels: {
      display: true,
      color: "black",
      formatter: Math.round,
      anchor: "end",
      offset: -20,
      align: "start"
    },
    scales: {
      xAxes: [{
          barPercentage: 0.1
      }]
  }
  },
  legend: {
    display: false
  }
};

const axes = React.useMemo(
  () => [
    { primary: true, type: "time", position: "bottom" },
    { type: "linear", position: "left" }
  ],
  []
);

const options = {
  colors: ['#C8463F', '#3A6CC4', '#FAC200'],
  chart: {
    type: 'pie',
    options3d: {
      enabled: true,
      alpha: 45,
      beta: 0
    }
  },
  title: {
    text: ''
  },
  tooltip: {
    pointFormat: '<b>{point.percentage:.1f}%</b>'
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      depth: 35,
      dataLabels: {
        enabled: true,
        format: '{point.name}'
      }
    }
  },
  series: [{
    data: [{
      name: 'Less than 40y ('+ Math.round(((pieChart_users.age1)/(pieChart_users.age1 + pieChart_users.age2 + pieChart_users.age3) * 100)) + ' %)',
      y: pieChart_users.age1,
    }, {
      name: '40y to 60y('+  Math.round(((pieChart_users.age2)/(pieChart_users.age1 + pieChart_users.age2 + pieChart_users.age3) * 100)) + ' %)',
      y: pieChart_users.age2,
    }, {
      name: 'Greater than 60y ('+  Math.round(((pieChart_users.age3)/(pieChart_users.age1 + pieChart_users.age2 + pieChart_users.age3) * 100)) + ' %)',
      y: pieChart_users.age3
    }]
  }],
  credits: false,
  exporting: {
    enabled: false
  }
}
Highcharts3D(Highcharts)
  return (
    <div className='wrapper'>
    <Sidebar />
    <div className='main  text-center'>
      <Header />
      <main className='ml-5 mr-3 mt-3 mb-3'>
      <b>Castor Programme Overview</b>
      <div className='col-md-12 row p-1'>
      <main class="content-wrapper">
          <div class="mdc-layout-grid">
            <div class="mdc-layout-grid__inner">
              <div class="mdc-layout-grid__cell stretch-card mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-3-tablet">
                <div class="mdc-card info-card info-card--info">
                  <div class="card-inner">
                    <h5 class="card-title">Outreach Farmers</h5>
                    <h2 class="font-weight-bold pb-2 mb-1  text-info">11386</h2>
                    <div class="card-icon-wrapper">
                      <img src="/images/images-w/farmer_outereached-w.png" className="img-fluid sidebar_icon" alt="image"/> 
                    </div>
                  </div>
                </div>
              </div>
              <div class="mdc-layout-grid__cell stretch-card mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-3-tablet">
                <div class="mdc-card info-card info-card--danger">
                  <div class="card-inner">
                    <h5 class="card-title">Trained Farmers</h5>
                    <h2 class="font-weight-bold pb-2 mb-1  text-danger">9039</h2>
                    <div class="card-icon-wrapper">
                    <img src="/images/images-w/farmer_trained-w.png" className="img-fluid sidebar_icon" alt="image"/> 
                    </div>
                  </div>
                </div>
              </div>
              <div class="mdc-layout-grid__cell stretch-card mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-3-tablet">
                <div class="mdc-card info-card info-card--warning">
                  <div class="card-inner">
                    <h5 class="card-title">Certified Farmers</h5>
                    <h2 class="font-weight-bold pb-2 mb-1 text-warning">7867</h2>
                    <div class="card-icon-wrapper">
                    <img src="/images/images-w/farmer_certified-w.png" className="img-fluid sidebar_icon" alt="image"/> 
                    </div>
                  </div>
                </div>
              </div>
              <div class="mdc-layout-grid__cell stretch-card mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-3-tablet">
                <div class="mdc-card info-card info-card--success">
                  <div class="card-inner">
                    <h5 class="card-title">Certified Production Area </h5>
                    <h2 class="font-weight-bold pb-2 mb-1 text-success">27281 </h2>
                    <h6 className='card-title'>Ha</h6>
                    <div class="card-icon-wrapper">
                    <img src="/images/images-w/farming_area-w.png" className="img-fluid sidebar_icon" alt="image"/> 
                    </div>
                  </div>
                </div>
              </div>
                <div class="mdc-layout-grid__cell stretch-card mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-3-tablet ">
                <div class="mdc-card info-card info-card--primary">
                  <div class="card-inner">
                    <h5 class="card-title">Certified Castor Produce </h5>
                    <h2 class="font-weight-bold pb-2 mb-1 text-primary">74967 </h2>
                    <h6 class="card-title">Tonnes </h6>
                    <div class="card-icon-wrapper">
                    <img src="/images/images-w/certified_produce-w.png" className="img-fluid sidebar_icon" alt="image"/> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        </div>
      <div className='container p-1'>
      <div className='row'>
        <b>Age composition of Project Farmers</b>
      <div className='col col-11'>
      <HighchartsReact
            highcharts={Highcharts}
            options={options}
          />
      </div>
        <ToastContainer/>
      <div className="box">
            <select className="form selectTag"  aria-label="Default select example search_select"  onChange={(value)=>{filteredByYear(value,value.target.value); setYear(value.target.value);}} >
              <option  >Select year</option>
              <option >2016</option>    
              <option >2017</option>
              <option >2018</option>
              <option >2019</option> 
              <option >2020</option> 
              <option >2021</option>  
              <option selected>2022</option>  
            </select>
        <select className="form selectTag"  aria-label="Default select example search_select"  onChange={(value)=>{filteredByDistrict(value); setDist(value.target.value); hideShowVillage(value.target.value);}} >
          <option  selected>Select District</option>
                  {useDistricts.map((data,i)=>{
                    return <option key={i} value={data.district}>{data.district}</option>
                  })}  
        </select>
        <select className="form selectTag"  aria-label="Default select example search_select" onChange={(value)=>filteredByVillage(value)}  style={{marginLeft:5}} 
              ref={selectInputRef} >
          <option value={0} >Select Village</option>
                  {
                  getVillages.length===0
                  ? "<option value={0} >select village</option>"
                  :getVillages.map((data,i)=>{
                    return <option key={i} value={data.village}>{data.village}</option>
                  })
                  }
        </select>
      </div>
      </div>
             

        </div>
      </main>
      <div className='card'>
        <div className='card-body text-center'>
          <div className=''>
            <div className='col-md-12 row'>
                <div className='col-md-6'>
                  {isLoading ? <Loader size="md"/> : 
                
                <ResponsiveContainer width="95%" height={400}>
                  <Bar data={setAvgDashboard1} plugins={[ChartDataLabels]} options={optionsForBar}  axes={axes} width={100} height={50} />
                </ResponsiveContainer>
                }
                </div>
                <div className='col-md-6'>
                  {isLoading ? <Loader size="md"/> : 
                
                <ResponsiveContainer width="95%" height={400}>
                  <Bar data={setAvgDashboard2} plugins={[ChartDataLabels]} options={optionsForBar}  axes={axes} width={100} height={50} />
                </ResponsiveContainer>
                }
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 
  </div>
  )
}
